import { render } from "./QimenPalaceWithFormationForPredict.vue?vue&type=template&id=0c025b74"
import script from "./QimenPalaceWithFormationForPredict.vue?vue&type=script&lang=js"
export * from "./QimenPalaceWithFormationForPredict.vue?vue&type=script&lang=js"

import "./QimenPalaceWithFormationForPredict.vue?vue&type=style&index=0&id=0c025b74&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__